<template>
  <v-form  v-model="isNewProductValid" onSubmit="return false;">
    <v-card>
      <v-card-title primary-title>
        <h1>Nueva Muestra</h1>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
             <v-flex xs12 md6>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field label="Numero de Serie"
                    v-model="newRecord.serial_number"
                    outline
                    >
                  </v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-text-field label="Platino"
                    v-model="newRecord.total_pt"
                    outline
                    type="number"
                    >
                    </v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-text-field label="Paladio"
                    v-model="newRecord.total_pd"
                    outline
                    type="number"
                    >
                    </v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-text-field label="Rodio"
                    v-model="newRecord.total_rh"
                    outline
                    type="number"
                    >
                  </v-text-field>
                </v-flex>
                <v-flex xs3>
                  <v-text-field label="Peso (gramos)"
                    v-model="newRecord.weigth_grams"
                    outline
                    type="number"
                    step="1"
                    @keypress.native="onlyDigits"
                    @paste.native.prevent="onPaste"
                    inputmode="numeric"
                    pattern="\d*"
                    >
                    </v-text-field>
                </v-flex>
                <v-flex xs9>
                  <v-text-field label="Descripcion"
                    v-model="newRecord.description"
                    outline
                    >
                    </v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-select label="Marca"
                    v-model="newRecord.maker_id"
                    outline
                    :items="this.makers"
                    item-text="name"
                    item-value="id"
                    >
                    </v-select>
                </v-flex>
                <v-flex xs6>
                  <v-select label="País"
                    v-model="newRecord.country_id"
                    outline
                    :items="this.countries"
                    item-text="name"
                    item-value="id"
                    >
                    </v-select>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 md6>
              <v-layout wrap>
                <v-flex xs12 text-xs-center>
                  <v-text-field label="Selecciona la Imagen" 
                    @click='pickFile' 
                    v-model='imageName' 
                    prepend-icon='attach_file'
                    outline>
                  </v-text-field>
                  <input
                    type="file"
                    style="display: none"
                    ref="image"
                    accept="image/*"
                    @change="onFilePicked"
                  >
                  <img :src="imageUrl" height="150" v-if="imageUrl"/>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    name="pictureName"
                    label="Nombre Imagen"
                    v-model="newPicture.path"
                    outline
                  ></v-text-field>
                </v-flex>                                         
              </v-layout>
            </v-flex>
           

          </v-layout>
          
            
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click="$emit('close-new-product')">Cancelar</v-btn>
        <v-btn color="success" @click="addProduct" :disabled="!isNewProductValid">Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>
<script>
import { getCountries, getMakers } from '../../services/catalogs';
export default {
  data() {
    return {
      isNewProductValid: false,
      newRecord: {},
      makers: [],
      countries: [],
      defaultNewRecord: {
        serial_number: '',
        total_pt: 0,
        total_pd: 0,
        total_rh: 0,
        weigth_grams: 0,
        country_id: null,
        maker_id: null,
        description: '',
      },
      // Add picture dialog data
      newPicture: {},
      imageName: '',
      imageUrl: '',
      imageFile: '',
    };
  },
  methods: {
  onlyDigits(e) {
      const char = String.fromCharCode(e.which || e.keyCode)
      if (!/\d/.test(char)) e.preventDefault()
    },
    onPaste(e) {
      const paste = (e.clipboardData || window.clipboardData).getData('text')
      if (!/^\d+$/.test(paste)) e.preventDefault()
      else this.newRecord.total_rh = paste.replace(/\D/g, '')
    },
    async addProduct() {
      const formData = new FormData();
      formData.append('image', this.imageFile);
      formData.append('pictureName', this.newPicture.path);
      formData.append('sampleData', JSON.stringify(this.newRecord));
      /* for (const key in this.newRecord) {
        if (p.hasOwnProperty(key)) {
          formData.append(key, this.newRecord[key]);
        }
      } */
      try {
        const result = await this.axios.post('/catalogs/product', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        this.imageName = '';
        this.imageFile = '';
        this.imageUrl = '';
        this.newRecord = Object.assign({}, this.defaultNewRecord);

        this.$emit('success', result.data);
      } catch (error)  {
        this.$emit('error', error.message);
      }
    },
    pickFile() {
      this.$refs.image.click();
    },

    onFilePicked(e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.imageName = files[0].name;
        if (this.imageName.lastIndexOf('.') <= 0) {
          return;
        }
        const fr = new FileReader ();
        fr.readAsDataURL(files[0]);
        fr.addEventListener('load', () => {
          this.imageUrl = fr.result;
          this.imageFile = files[0]; // this is an image file that can be sent to server...
        });
      } else {
        this.imageName = '';
        this.imageFile = '';
        this.imageUrl = '';
      }
    },
  },
  mounted() {
    this.newRecord = Object.assign({}, this.defaultNewRecord);
    getMakers()
      .then((results) => {
        this.makers = results.data;
      })
      .catch((error) => {
        this.$emit('error', error.message);
      });
    getCountries()
      .then((results) => {
        this.countries = results.data;
      }).catch((error) => {
        this.$emit('error', error.message);
      });
  },
};
</script>

